import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	return: {
		id: 'project-create-importer-upload-flow.upload-screen.return',
		defaultMessage: 'Return to import your data',
		description: 'Button text to return to import data step',
	},
});
